import { render } from "./EditButton.vue?vue&type=template&id=2af9896c&scoped=true&bindings={\"isEditing\":\"props\"}"
import script from "./EditButton.vue?vue&type=script&lang=js"
export * from "./EditButton.vue?vue&type=script&lang=js"

import "./EditButton.vue?vue&type=style&index=0&id=2af9896c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2af9896c"

export default script